/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';
import {I18nService} from '../../_services/i18n.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {ExternalImportRemovalService} from '../../_services/external-import-removal.service';
import {Helpers} from '../../helpers';
import {HttpErrorResponse} from '@angular/common/http';
import {HOME_PATH, REMOVAL_PATH} from '../../_enums/constants';

@Component({
  selector: 'app-pay-pal-canceled',
  templateUrl: './pay-pal-canceled.component.html',
  styleUrls: ['./pay-pal-canceled.component.scss']
})
export class PayPalCanceledComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public externalRemovalId: number;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private externalImportRemovalService: ExternalImportRemovalService,
    private i18n: I18nService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    this.externalRemovalId = this.pathId;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get pathId(): number | null {
    if (this.route.snapshot.queryParams.id) {
      return Number(this.route.snapshot.queryParams.id);
    }

    if (this.route.snapshot.params.id) {
      return Number(this.route.snapshot.params.id);
    }

    return null;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public cancel(): void {
    this.router.navigate([HOME_PATH]);
  }

  public replay(): void {
    if (this.externalRemovalId) {
      Helpers.setLoading(true);

      this.externalImportRemovalService.getById(this.externalRemovalId, {version: 1.3}).subscribe(() => {
        Helpers.setLoading(false);
        this.router.navigate([REMOVAL_PATH, this.externalRemovalId]);
      }, (err: HttpErrorResponse) => this.handleError(err));
    } else {
      this.router.navigate([HOME_PATH]);
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);

    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
